export default {
  COMMON: {
    REJECT: 'Avvis',
    CONTINUE: 'Fortsett',
    SIGN: 'Signer',
    LOADING: 'Laster...',
    VERIFY: 'Verifiser',
    CANCEL: 'Avbryt',
    VIEW: 'Vis',
    DOWNLOAD: 'Last ned',
    ATTACHMENTS: 'Vedlegg',
    DOCUMENTS: 'Dokumenter',
    READ: 'Lest',
    CHECKED: 'Sjekket',
  },

  APPROVER_INBOX: {
    TITLE: 'Ordreinnboks',
    SUBTITLE: 'Velg ordrene du vil signere.',
    SELECT_ALL: 'Velg alle ordre',
    SELECT_ALL_ORDERS: 'Velg alle ordre',
    LOADING: 'Laster innboks...',
    EMPTY: 'Ingen ordre funnet.',
    EMPTY_TITLE: 'Ingen underskriftsordre til godkjenning',
    EMPTY_SUBTITLE: 'Det er for øyeblikket ingen underskriftsordre som venter på din godkjenning.',
    ERROR_LOAD: 'Kunne ikke laste innboksen.',
    UNKNOWN_SENDER: 'Ukjent avsender',
    SENT_YOU_FILES: 'sendte deg dokumenter for signering',
    VIEW_FILE: 'Vis fil',
    REJECT_ORDER: 'Avslå ordre',
    REVIEW_SELECTED: 'Se gjennom valgte ({{count}})',
    EXPAND: 'Utvid',
    COLLAPSE: 'Skjul',
    CREATED: 'Opprettet',
    ONE_FILE: '1 fil',
    MANY_FILES: 'dokumenter',
    MORE: 'Flere',
    COPY_HASHSUM: 'Kopier hashsum',
  },
  APPROVER_SIGN: {
    TITLE: 'Avtaledokumenter til signering',
    INSTRUCTION: 'Jeg har lest og aksepterer innholdet i følgende avtaledokumenter. Når jeg har signert avtalene, er de bindende for meg.',
  },
  TAB_DETECTION: {
    TITLE: 'Denne URL-lenken er allerede i bruk i en annen fane.',
    SUBTITLE: 'Lukk den andre fanen, og last deretter inn denne siden på nytt.',
  },

  FORMS: {
    NO_COUNTRIES_FOUND: 'Ingen land funnet',
    NO_RESULTS_FOUND: 'Ingen resultater funnet',
    CHOOSE_FILES: 'Velg filer',
    NO_FILE_CHOSEN: 'Ingen fil valgt',
    SELECT_AN_OPTION: 'Velg et alternativ',
    SEARCH: 'Søk...',
    ERRORS: {
      REQUIRED: 'Dette feltet er påkrevd',
      EMAIL: 'Vennligst skriv inn en gyldig e-postadresse',
      MIN_LENGTH: 'Minimum lengde er {{requiredLength}} tegn',
      MAX_LENGTH: 'Maksimal lengde er {{requiredLength}} tegn',
      INVALID: 'Ugyldig verdi',
      ONLY_NUMBERS: 'Kun tall er tillatt',
      FILE_TYPE: 'Filen må være jpeg, jpg, bmp, gif eller pdf',
      CPR_ONLY_DIGITS: 'CPR må bare inneholde sifre',
      CPR_LENGTH: 'CPR må være nøyaktig 10 sifre',
      CPR_INVALID: 'CPR-nummeret er ikke gyldig',
      BANK_ACCOUNT_REG_ONLY_NUMERIC: 'Kun tall er tillatt',
      BANK_ACCOUNT_REG_FOUR_DIGITS: 'Registreringsnummeret må være nøyaktig 4 sifre',
      CVR_ONLY_NUMERIC: 'Kun tall er tillatt',
      CVR_EIGHT_DIGITS: 'CVR må være nøyaktig 8 sifre',
    },
  },

  CALENDAR: {
    DAYS: {
      SUN: 'Søn',
      MON: 'Man',
      TUE: 'Tir',
      WED: 'Ons',
      THU: 'Tor',
      FRI: 'Fre',
      SAT: 'Lør',
    },
    MONTHS: {
      JANUARY: 'Januar',
      FEBRUARY: 'Februar',
      MARCH: 'Mars',
      APRIL: 'April',
      MAY: 'Mai',
      JUNE: 'Juni',
      JULY: 'Juli',
      AUGUST: 'August',
      SEPTEMBER: 'September',
      OCTOBER: 'Oktober',
      NOVEMBER: 'November',
      DECEMBER: 'Desember',
    },
  },

  SIGNATURE: {
    CLEAR_SIGNATURE: 'Tøm Signatur',
    YOUR_SIGNATURE: 'Din Signatur',
    AGREEMENT_DOCUMENT_TITLE: 'Avtaledokument til underskrift',
    AGREEMENT_DOCUMENT_DESCRIPTION: 'Ved å signere avtalen angir jeg at jeg har lest og akseptert innholdet i følgende avtaledokument. Min underskrift er bindende.',
    FORM_DESCRIPTION: 'Ved å signere skjemaet angir jeg at jeg har lest og akseptert innholdet i følgende skjema. Min underskrift er bindende.',
    SIGN_HERE: 'Skriv under her',
  },

  STEPS: {
    LOGIN_SHARED_SECRET: 'Logg inn med avtalte koden',
    LOGIN_OTP: 'Logg inn med OTP',
    LOGIN_EID: 'Logg inn med eID',
    LOGIN_MITID: 'Logg inn med MitID',
    REVIEW_FILES: 'Gjennomgå filer',
    REVIEW_DOCUMENTS: 'Les dokumenter',
    REVIEW_FORMS: 'Les skjemaer',
    ORDER_QUESTIONS: 'Svar spørsmål',
    SIGN: 'Signer dokument',
    SIGN_FORM: 'Skjema til signering',
    RECEIPT: 'Kvittering',
    DOWNLOAD: 'Last ned',
    CPR: 'CPR-verifisering',
    FILE: 'Filopplasting',
    FILES: 'Sikker ePost',
    APPROVER_REVIEW_FILES: 'Ordreinnboks',
    APPROVER_SIGN: 'Avtaledokumenter til signering',
  },
  LOGIN_OTP: {
    INSTRUCTION: 'Vennligst skriv inn SMS-koden du har mottatt på din mobil. Koden er sendt til telefonnr. {{ phoneNumber }}.',
    OTP_CODE: 'OTP Kode',
    OTP_EXPIRED: 'Engangskoden har utløpt. Vennligst be om en ny.',
    RESEND_OTP: 'Send OTP på nytt',
    RESEND_OTP_IN: 'Send OTP på nytt om',
    OTP_PHONE_INSTRUCTION: 'Vennligst skriv inn den 6-sifrede koden som ble sendt til din telefon.',
  },
  LOGIN_SHARED_SECRET: {
    INSTRUCTION: 'For å bekrefte identiteten din og få tilgang til dokumentene dine, vennligst skriv inn den avtalte koden du har mottatt fra {{ senderName }}.',
    SHARED_SECRET: 'Avtalt kode',
    SHARED_SECRET_ERROR: 'Den avtalte koden stemmer ikke',
    SHARED_SECRET_REQRUIRED: 'Den avtalte koden er påkrevd',
  },

  LOGIN_EID: {
    POPUP_ALERT: 'Vennligst deaktiver popup-blokkeringen din og prøv igjen.',
    ORIGIN_MISMATCH: 'Sikkerhetsadvarsel: Identitetsleverandørens opprinnelse samsvarer ikke. Vennligst prøv igjen.',
    SUCCESS: 'Du er nå logget inn.',
    AUTHENTICATED: 'Autentisering vellykket.',
    ERROR: 'Innlogging mislyktes. Vennligst prøv igjen.',
    INSTRUCTION: 'For å få sikker tilgang til å signere dokumentene dine, vennligst logg inn med din eID. Velg en innloggingsmetode nedenfor for å fortsette.',
    SINGLE_PROVIDER_INSTRUCTION: 'For å få sikker tilgang til å signere dine dokumenter skal du logge inn for å fortsette.',
    FORM_INSTRUCTION: 'For å få sikker tilgang til å signere skjemaet ditt, vennligst logg inn med din eID. Velg en innloggingsmetode nedenfor for å fortsette.',
    FORM_SINGLE_PROVIDER_INSTRUCTION: 'For å få sikker tilgang til å signere skjemaet ditt skal du logge inn for å fortsette.',
    CPR_INSTRUCTION: 'Vi ber deg logge inn med MitID/eID for å bekrefte identiteten din. Velg en innloggingsmetode nedenfor for å fortsette.',
    CPR_SINGLE_PROVIDER_INSTRUCTION: 'Vi ber deg logge inn med MitID/eID for å bekrefte identiteten din.',
    PROVIDERS: {
      mitid: 'Logg inn med MitID',
      'mitid-business': 'Logg inn med MitID Bedrift',
      bankid_no: 'Logg inn med norsk BankID',
      swedish_bank_id: 'Logg inn med Svensk BankID',
      default: 'Logg inn med {{name}}',
    },
    MITID_BUSINESS_SUBTITLE: 'Kan brukes hvis din bedrift/forening har tilknyttet seg MitID Næringsliv',
  },

  REVIEW_FILES: {
    INSTRUCTION: 'Du bes hente eller åpne alle vedlegg.\nNår alt er hentet eller åpnet, vil avsender motta en varsling om dette\nNår alle vedlegg er hentet eller åpnet, kan du gå videre til din kvittering',
    SHOW_ALL_SIGNERS: 'Status for undertegnere',
    ATTACHMENTS: 'Vedlegg',
    DESCRIPTION: 'Se hvilke personer som har signert, og hvilke som mangler.',
    NO_SIGNERS_FOUND: 'Ingen undertegnere funnet',
    FILES_LEFT: 'Du trenger å lese de resterende {{count}}, dokument(er).',
    FILES_READ_ALL: 'Du har lest alle dokumentene. Du kan nå gå videre til signaturen.',
    FORM_FILES_LEFT: 'Du trenger å lese de resterende {{count}} skjema(er).',
    FORM_FILES_READ_ALL: 'Du har lest alle skjemaene. Du kan nå gå videre til signaturen.',
    GO_TO_RECEIPT: 'Gå til kvittering',
    CONTINUE: 'Fortsett',
    FILES: 'Dokumenter',
  },

  REVIEW_DOCUMENTS: {
    INSTRUCTION: 'Vennligst åpne og les alle dokumenter og eventuelle vedlegg nedenfor.',
    FORM_INSTRUCTION: 'Vennligst åpne og les alle skjemaer og eventuelle vedlegg nedenfor.',
    FILES: 'Dokumenter',
    FORM_FILES_ONE: 'Skjema',
    FORM_FILES_MANY: 'Skjemaer',
    SHOW_ALL_SIGNERS: 'Status for undertegnere',
    ATTACHMENTS: 'Vedlegg',
    DESCRIPTION: 'Se hvilke personer som har signert, og hvilke som mangler.',
    NO_SIGNERS_FOUND: 'Ingen undertegnere funnet',
  },

  SIGN_DOCUMENT: {
    INSTRUCTION: 'Vennligst åpne og les alle dokumenter og eventuelle vedlegg nedenfor.',
  },

  ORDER_QUESTIONS: {
    INSTRUCTION: 'Vennligst fyll inn feltene nedenfor.',
    LOADING: 'Laster spørsmål...',
    SAVING: 'Lagrer...',
    REQUIRED_FIELDS_WARNING: 'obligatoriske spørsmål er ikke besvart',
    GOTO_FIRST_UNANSWERED: 'Gå til første',
    INPUTS_NOT_EQUAL: 'Det du har skrevet inn er ikke likt',
    ENTER_FIELD_PLACEHOLDER: 'Skriv inn {{field}}',
    ENTER_ZIP_CODE_PLACEHOLDER: 'Skriv inn postnummer',
    ENTER_EMAIL_PLACEHOLDER: 'Skriv inn e-postadresse',
    ENTER_VALUE_PLACEHOLDER: 'Skriv inn verdi',
    YES: 'Ja',
    NO: 'Nei',
    ERRORS: {
      REQUIRED: 'Dette feltet er obligatorisk.',
      EMAIL: 'Skriv inn en gyldig e-postadresse.',
      CPR: 'Skriv inn et gyldig CPR-nummer.',
      CVR_ONLY_NUMERIC: 'Kun tall er tillatt.',
      CVR_EIGHT_DIGITS: 'CVR må være nøyaktig 8 sifre.',
      BANK_REGISTRATION_NUMBER_ONLY_NUMERIC: 'Kun tall er tillatt.',
      BANK_REGISTRATION_NUMBER_FOUR_DIGITS: 'Registreringsnummer må være nøyaktig 4 sifre.',
      PATTERN: 'Ugyldig format.',
      VALUE_NOT_ALLOWED: 'Denne verdien kan ikke brukes. Vennligst skriv inn en annen.',
      BACKEND_INVALID: 'Verdien kunne ikke lagres. Prøv igjen.',
      FILE_TYPE: 'Denne filtypen er ikke tillatt.',
      INVALID: 'Ugyldig verdi.',
    },
  },

  RECEIPT: {
    SUCCESS_HEADING: 'Signaturen din er fullført',
    FILES_ORDER_SUCCESS_HEADING: 'Filene dine er hentet',
    FILES_ORDER_SUCCESS_MESSAGE: 'Det er sendt en e-post til',
    SUCCESS_MESSAGE: 'Vi har sendt en kvittering for signaturen din til',
    SUCCESS_COMPLETION: 'Først når alle har signert, vil du motta en e-post med en lenke til det signerte dokumentet',
    SUCCESS_COMPLETION_SINGLE_SIGNER: 'En e-post med en lenke til det/de signerte dokumentet(ene) er sendt til din e-post',
    FORM_SUCCESS_COMPLETION: 'Først når alle har signert, vil du motta en e-post med en lenke til det signerte skjemaet',
    FORM_SUCCESS_COMPLETION_SINGLE_SIGNER: 'En e-post med en lenke til det signerte skjemaet er sendt til din e-post',
    REFERENCE_ID: 'Referanse-ID',
    LOGGED_OUT_MESSAGE: 'Du har blitt logget ut automatisk og kan nå lukke dette vinduet',
    ALL_SIGNERS: 'Alle undertegnere',
    ALL_SIGNERS_SINGLE_SIGNER: 'Undertegner',
    DOWNLOAD_MESSAGE: 'Vær oppmerksom på at du har 90 dager på deg til å laste ned din kopi av avtaledokumentet. Alt du trenger å gjøre er å følge lenken i e-posten vi har sendt deg.',
    FORM_DOWNLOAD_MESSAGE: 'Vær oppmerksom på at du har 90 dager på deg til å laste ned din kopi av skjemaet. Alt du trenger å gjøre er å følge lenken i e-posten vi har sendt deg.',
    FILES_ORDER_DOWNLOAD_MESSAGE: ', som inneholder en kvittering og en lenke til filene dine.\nMerk at du har 90 dager til å laste ned din kopi av innholdet. Alt du trenger å gjøre er å følge lenken i e-posten som ble sendt til deg.',
    FILES_ORDER_REJECTED_HEADING: 'Bestillingen er kansellert',
    FILES_ORDER_REJECTED_MESSAGE: 'Det ble sendt en melding til avsender.',
    REJECTED_BY_OWNER_TITLE: 'Ordre kansellert av eier',
    REJECTED_BY_OWNER_MESSAGE: 'Denne ordren har blitt kansellert av eieren.',
    REJECTED_BY_SIGNER_TITLE: 'Ordre kansellert - signatur avvist',
    REJECTED_BY_SIGNER_MESSAGE: 'Denne ordren har blitt kansellert fordi en av undertegnerne avviste å signere.',
    NO_SIGNATURE_REQUIRED_HEADING: 'Suksess',
    NO_SIGNATURE_REQUIRED_REJECTED_HEADING: 'Bestillingen er kansellert',
    NO_SIGNATURE_REQUIRED_MESSAGE: 'En e-post er sendt til',
    NO_SIGNATURE_REQUIRED_REJECTED_MESSAGE: 'Det ble sendt en melding til avsender.',
    NO_SIGNATURE_REQUIRED_MESSAGE_SUFFIX: ', den inneholder en kvittering og en lenke til avtaledokumentet. Du har 90 dager til å hente din kopi av avtalen ved å følge lenken i e-posten.',
  },

  STATUS: {
    SIGNED: 'Signert',
    RECEIVED: 'Mottatt',
    PENDING: 'Venter',
    REJECTED: 'Avvist',
    LOCKED: 'Låst',
  },

  NOT_FOUND: {
    TITLE: 'Siden ikke funnet',
    DESCRIPTION: 'Siden du leter etter finnes ikke, eller signeringslenken er ugyldig.',
  },

  NO_SUCH_APPROVER: {
    TITLE: 'Intern underskriver ikke gjenkjent',
    DESCRIPTION: 'Det finnes ingen interne underskrivere som matcher det benyttede MitId.',
  },

  NO_ACCESS_CPR: {
    TITLE: 'CPR-sjekket kunne ikke gjennomføres',
    DESCRIPTION: 'MitID-en som ble brukt stemmer ikke overens med CPR-nummeret som skal sjekkes. Du bes kontakte {{senderName}} og oppgi referansenr. {{referenceId}}.',
  },

  ARCHIVED: {
    TITLE: 'Signeringsordren er ikke tilgjengelig',
    DESCRIPTION: 'Den signeringsordren som du prøver å få tilgang til, er dessverre ikke lenger tilgjengelig. 90 dager etter at siste underskriver har gitt sin underskrift, slettes signeringsordren og tilhørende dokumenter.',
  },

  ALREADY_SIGNED: {
    TITLE: 'Allerede signert',
    DESCRIPTION: 'Denne signeringsordren er allerede signert.',
  },

  CPR_ALREADY_SIGNED: {
    TITLE: 'CPR-ordre allerede signert',
    DESCRIPTION: 'Denne CPR-signeringsordren er allerede fullført.',
  },

  VERIFY_ERROR: {
    TITLE: 'Verifisering mislyktes',
    DESCRIPTION: 'Identiteten brukt til signering stemmer ikke med den som kreves for denne ordren.',
  },

  ORDER_MISMATCH: {
    TITLE: 'Ordre stemmer ikke overens',
    DESCRIPTION: 'Signeringsordren stemmer ikke med den gjeldende økten. Lukk andre faner og prøv igjen.',
  },

  PSEUDONYM_DISALLOWED: {
    TITLE: 'Pseudonyme brukere er ikke tillatt',
    DESCRIPTION: 'Kunden tillater ikke signering med en pseudonym identitet.',
  },

  EXPIRED: {
    TITLE: 'Fristen for signeringsordren har utløpt',
    DESCRIPTION: 'Avsenderen av denne signeringsordren - {{documentReference}} - har satt en frist for når signeringsordren senest kan signeres. Fristen har nå utløpt.',
    SUB_DESCRIPTION: 'Kontakt avsenderen {{senderName}} dersom du er usikker eller tror at det har oppstått en feil.',
    MORE_INFO: 'Klikk her for mer informasjon',
    INFO_TITLE: 'Hvorfor er det en tidsfrist?',
    INFO: 'Alle signeringsordrer har en tidsfrist. På denne måten kan avsender sikre at signeringsordren signeres innenfor avsenderens valgte kriterier.',
    SUB_TITLE: 'Hva gjør jeg nå?',
    SUB_INFO: 'Avsenderen er blitt gjort oppmerksom på at én eller flere parter ikke har signert innenfor tidsfristen. Du kan enten vente på at avsenderen kontakter deg, eller kontakte avsenderen på nytt.',
  },

  STEP_LOCKED: {
    TITLE: 'Dette trinnet er for øyeblikket låst',
    DESCRIPTION: 'Dette signeringstrinnet er låst og kan ikke fullføres på dette tidspunktet. Vennligst kontakt avsenderen for mer informasjon.',
  },

  UNEXPECTED: {
    TITLE: 'Det oppsto en uventet feil',
    DESCRIPTION: 'Det oppsto en uventet feil under behandlingen av din anmodning. Vennligst prøv igjen senere.',
  },

  STEP_NOT_AVAILABLE: {
    TITLE: 'Dette trinnet er ikke tilgjengelig ennå',
    DESCRIPTION: 'Dette signeringstrinnet er ikke tilgjengelig ennå. Vennligst vent til forrige trinn er fullført før du fortsetter.',
  },

  UNAUTHORIZED: {
    TITLE: 'Det oppstod en feil',
    DESCRIPTION: 'Vi kunne ikke verifisere signeringsøkten. Prøv igjen via lenken du har mottatt, eller kontakt avsender.',
  },

  ERRORS: {
    UNAUTHORIZED: 'Du er ikke autorisert til å få tilgang til denne ressursen',
    BAD_REQUEST: 'Ugyldig forespørsel. Vennligst sjekk inndataene dine',
    FORBIDDEN: 'Tilgang til denne ressursen er forbudt',
    NOT_FOUND: 'Den forespurte ressursen ble ikke funnet',
    SERVER_ERROR: 'Det oppstod en feil på serveren. Vennligst prøv igjen senere',
    UNKNOWN_ERROR: 'Det oppstod en uventet feil. Vennligst prøv igjen',
    SESSION_EXPIRED: 'Økten din har utløpt. Du blir omdirigert til innlogging.',
  },

  RECEIPT_CPR: {
    SUCCESS_HEADING: 'Din identifikasjon er nå bekreftet.',
    SUCCESS_MESSAGE: 'Vi har sendt en kvittering for din CPR-sjekk til',
    REJECTED_HEADING: 'Signeringen nektet',
    REJECTED_MESSAGE: 'En melding er sendt til',
  },

  CPR_CHECK: {
    INSTRUCTION: 'Vennligst skriv inn ditt CPR-nummer',
    CPR_NUMBER: 'CPR-nummer',
    CPR_NUMBER_PLACEHOLDER: 'Skriv inn ditt personnummer',
    HEALTH_INSURANCE_CARD: 'Last opp et bilde av ditt helseforsikringskort',
    PHOTO_ID: 'Last opp en kopi av foto-ID - f.eks. pass eller førerkort',
    FILE_HINT: "Støttede formater: 'png', 'jpg', 'bmp'. Maks filstørrelse: 10 MB.",
    PROTECTED_CPR_PHOTO_ID_REQUIRED: 'Siden du har adressebeskyttelse, kan vi ikke verifisere opplysningene dine. Vennligst fyll ut feltene nedenfor.',
  },

  REJECT_MODAL: {
    TITLE: 'Vil du avvise denne ordren?',
    REASON_PLACEHOLDER: 'Skriv din grunn for avvisning',
    CONFIRM: 'Bekreft avvisning',
  },

  DOWNLOAD_STEP: {
    HEADING: 'Last ned dokumentene dine',
    DESCRIPTION: 'Du kan nå laste ned en kopi av de signerte dokumentene dine. Dokumentene er tilgjengelige i 90 dager fra datoen de ble signert. Klikk på last knappen for å lagre dem lokalt på datamaskinen din.',
    DOWNLOAD_BUTTON: 'Last ned kopi',
    LOGOUT_BUTTON: 'Logg ut',
    LOGGED_OUT_HEADING: 'Du har blitt logget ut',
    LOGGED_OUT_DESCRIPTION: 'Takk for at du bruker Esignatur. Vi ser frem til å se deg igjen.',
  },

  LOGOUT_MODAL: {
    TITLE: 'Logg ut?',
    DESCRIPTION: 'Er du sikker på at du vil logge ut? Eventuelle endringer vil gå tapt.',
    CONFIRM: 'Logg ut',
  },

  REJECTION_SUCCESS_MODAL: {
    TITLE: 'Ordren ble avvist',
    DESCRIPTION: 'Denne ordren har blitt avvist',
    CONTINUE: 'Fortsett',
  },

  APPROVER_RECEIPT: {
    SUCCESS_HEADING: 'Dine signaturer ble fullført.',
    SUCCESS_MESSAGE: 'Du har automatisk blitt logget ut og kan nå lukke dette vinduet.',
  },

  SUPPORT: {
    CONTACT: 'Kontakt oss via e-post:',
  },
};
